
import { defineComponent } from "vue";
import VueyePhoneInput from "./components/VueyePhoneInput";

export default defineComponent({
  name: "app",
  components: {
    VueyePhoneInput,
  },
  data() {
    return {
      status:'',
      phone: {
        number: "",
        nationalNumber: "",
        isValid:false,
        callingCode:''
      },
    };
  },

  methods: {
   filldata(){
      this.phone= {
        number: "+9312345678",
        nationalNumber: "12345678",
        isValid:true,
        callingCode:'93'
      }
   }
  },
});
